import { useEffect, useRef, useState } from "react";
import "./styles.css";

const TextInput = ({ inputRef, onChange, isRequired, defaultValue, readOnly, onInput }) => {
  return (
    <input
      type="text"
      className="text-input"
      ref={inputRef}
      onBlur={onChange}
      required={isRequired}
      defaultValue={defaultValue}
      onChange={onInput}
      readOnly={readOnly}
    />
  );
}

const PasswordInput = ({ inputRef, onChange, isRequired, defaultValue, readOnly, onInput }) => {
  return (
    <input
      type="password"
      className="text-input"
      ref={inputRef}
      onBlur={onChange}
      required={isRequired}
      defaultValue={defaultValue}
      readOnly={readOnly}
      onChange={onInput}
    />
  );
}

const DateInput = ({ inputRef, onChange, isRequired, defaultValue, readOnly }) => {
  return (
    <input
      type="date"
      className="date-input"
      ref={inputRef}
      onBlur={onChange}
      required={isRequired}
      defaultValue={defaultValue}
      readOnly={readOnly}
    />
  );
}

const SelectInput = ({ inputRef, onChange, onBlur, isRequired, defaultValue, options = [], readOnly }) => {
  return (
    <select
      defaultValue={defaultValue}
      onBlur={onBlur}
      ref={inputRef}
      onChange={onChange}
      required={isRequired}
      disabled={readOnly}
    >
      {!defaultValue && (<option disabled selected></option>)}
      {options.map(optionItem => (
        <option value={optionItem.value}>{optionItem.label}</option>
      ))}
    </select>
  );
}

const TextAreaInput = ({ inputRef, onChange, isRequired, defaultValue, readOnly }) => {
  return (
    <textarea
      row="3"
      required={isRequired}
      ref={inputRef}
      onBlur={onChange}
      defaultValue={defaultValue}
      readOnly={readOnly}
    ></textarea>
  )
}

const Input = ({ label, type = "text", isRequired, defaultValue, options, readOnly, onChange, onInput }) => {
  const [value, setValue] = useState();
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    setValue(defaultValue || "")
  }, [defaultValue])
  
  const inputRef = useRef();

  const handleClick = (event) => {
    setIsActive(true);

    inputRef.current.focus();
  };

  const handleOnchange = (event) => {
    const newVal = event.target.value;

    setValue(newVal);
    setIsActive(false);

    if (onChange) onChange(newVal)
  };

  return (
    <div
      className={`input__container ${(isActive || value) && `active`} ${
        isActive && `editing`
      } ${type === "textarea" && `textarea`} ${readOnly && `read-only`}`} 
      onClick={handleClick}
    >
      <div className="label">{label}</div>
      
      {type === "text" && (
        <TextInput
          inputRef={inputRef}
          onChange={handleOnchange}
          isRequired={isRequired}
          defaultValue={defaultValue}
          readOnly={readOnly}
          onInput={onInput}
        />
      )}

      {type === "password" && (
        <PasswordInput
          inputRef={inputRef}
          onChange={handleOnchange}
          isRequired={isRequired}
          defaultValue={defaultValue}
          readOnly={readOnly}
          onInput={onInput}
        />
      )}

      {type === "date" && (
        <DateInput
          inputRef={inputRef}
          onChange={handleOnchange}
          isRequired={isRequired}
          defaultValue={defaultValue}
          readOnly={readOnly}
        />
      )}

      {type === "select" && (
        <SelectInput
          inputRef={inputRef}
          onChange={handleOnchange}
          isRequired={isRequired}
          defaultValue={defaultValue}
          options={options}
          onBlur={() => setIsActive(false)}
          readOnly={readOnly}
        />
      )}

      {type === "textarea" && (
        <TextAreaInput
          inputRef={inputRef}
          onChange={handleOnchange}
          isRequired={isRequired}
          defaultValue={defaultValue}
          readOnly={readOnly}
        />
      )}

      {type === "time" && (
        <div className={`time__input--container ${(readOnly && !defaultValue) && "read-only"}`}>
          <input
            ref={inputRef}
            type="time"
            value={defaultValue}
            onChange={handleOnchange}
            readOnly={readOnly}
            required
          />
        </div>
      )}
    </div>
  )
};

export default Input;